import { render, staticRenderFns } from "./StudentInviteList.vue?vue&type=template&id=58ce983e&scoped=true"
import script from "./StudentInviteList.vue?vue&type=script&lang=js"
export * from "./StudentInviteList.vue?vue&type=script&lang=js"
import style0 from "./StudentInviteList.vue?vue&type=style&index=0&id=58ce983e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ce983e",
  null
  
)

export default component.exports